module.exports = __webpack_public_path__ + "static/img/3.03187ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/newbieGuide/img/3.png
// module id = TgMz
// module chunks = 115